    <mat-dialog-content>
        <div tabindex="0">
            <ng-container *ngTemplateOutlet="data.content"></ng-container>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-flat-button class="subtle-button-color" mat-dialog-close  i18n="close text@@close-text">Close</button>
    </mat-dialog-actions>



